<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="warehouses"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" :title="$t('pages_warehouses_index_1141')">
      <Form ref="warehouse" :model="warehouse" :label-width="120">
        <Form-item :label="$t('pages_warehouses_index_1142')" prop="booking">
          <Select
            v-model="warehouse.fresh_booking_id"
            style="width: 200px;"
            :placeholder="$t('pages_cleaner_index_267')"
            :label="warehouse.fresh_booking_code"
          >
            <Option
              v-for="(cat, index) in bookings"
              :value="cat.id"
              :key="index"
              >{{ cat.code }}</Option
            >
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_warehouses_index_1143')" prop="depot">
          <Select
            v-model="warehouse.fresh_depot_id"
            style="width: 200px;"
            :placeholder="$t('pages_warehouses_index_1143')"
            :label="warehouse.fresh_depot_name"
          >
            <Option
              v-for="(cat, index) in depots"
              :value="cat.id"
              :key="index"
              >{{ cat.name }}</Option
            >
          </Select>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_warehouses_index_1144'),
          key: 'code',
          align: 'center',
          width: 200
        },
        {
          title: i18n.t('pages_warehouses_index_1145'),
          key: 'created_at_str',
          align: 'center',
          width: 180
        },
        {
          title: i18n.t('pages_bookings_index_228'),
          key: 'user_name',
          align: 'center',
          width: 180
        },
        {
          title: i18n.t('pages_cleaner_index_260'),
          key: 'fresh_depot_name',
          align: 'center',
          width: 200
        },
        {
          title: i18n.t('pages_bookings_index_230'),
          key: 'note'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 100,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            // children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.depot_index()
    this.booking_index({ per: 100 })
  },
  computed: {
    ...mapGetters('warehouse', ['warehouse', 'warehouses', 'meta', 'loading']),
    ...mapGetters('depot', ['depots']),
    ...mapGetters('booking', ['bookings'])
  },
  methods: {
    ...mapActions('warehouse', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('depot', { depot_index: 'index' }),
    ...mapActions('booking', { booking_index: 'index' }),
    ...mapMutations('warehouse', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.warehouse)
      } else if (this.formType === 'new') {
        await this.create(this.warehouse)
      }
      this.modalShow = false
    }
  }
}
</script>
